import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import { routes } from "./routes";
import LoginPage from "./components/features/Login/LoginPage";
import RegisterPage from "./components/features/Register/RegisterPage";
import VertifyOTP from "./components/features/Register/VerifyOtpPage";
import HomePage from "./components/features/Home/HomePage";
import DefaultLayout from "./components/layout/DefaultLayout";
import ProtectedLayout from "./components/layout/ProtectedLayout";
import ForgetPasswordPage from "./components/features/Register/ForgetPasswordPage";
import ResetPasswordOTPPage from "./components/features/Register/ResetPasswordOTPPage";
import { PATH_NAME, PRODUCT_ROUTE_PATHS } from "./configs/pathName";
import { getCurrentBrand } from "./configs/brandConfigs";
import ProductPage from "./components/features/Product/ProductPage";
import SingleCollectionPage from "./components/features/ShopAll/SingleCollectionPage";
import Checkout from "./components/features/Checkout/Checkout";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SmartFridgePage from "./components/features/SmartFridge/SmartFridge";
import LocationsPage from "./components/features/Locations/LocationsPage";
import MenuPage from "./components/features/Menu/MenuPage";
import ShopAllPage from "./components/features/ShopAll/ShopAllPage";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Profile from "./components/features/Profile/ProfilePage";
import RefundPrivacyPolicyPage from "./components/features/PrivacyPolicy/PrivacyPolicyPage";
import CartPage from "./components/features/Cart/cart";
import GuestPayment from "./components/features/Checkout/guestPayment";
import DeleteAccountPage from "./components/features/DeleteAccount/DeleteAccountPage";

const lightTheme = createTheme({
  palette: {
    mode: "light",
  },
});

const ForceRefresh = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return <>{children}</>;
};

function App() {
  if (!getCurrentBrand()) {
    return (
      <main role="alert">
        This hostname is not configured for this application.
      </main>
    );
  }

  return (
    <BrowserRouter>
      <ForceRefresh>
        <Routes>
          <Route element={<DefaultLayout />}>
            <Route path={PATH_NAME.ROOT} element={<HomePage />} />
            <Route path={PATH_NAME.LOCATIONS} element={<LocationsPage />} />
            <Route path={PATH_NAME.ALLPRODUCTS} element={<ShopAllPage />} />
            <Route
              path={PATH_NAME.COLLECTIONS}
              element={<SingleCollectionPage />}
            />
            <Route path={PATH_NAME.SMART_FRIDGE} element={<SmartFridgePage />} />
            <Route path={PATH_NAME.DELETE_ACCOUNT} element={<DeleteAccountPage />} />
            <Route path={PATH_NAME.MENU} element={<MenuPage />} />
            <Route path={PATH_NAME.LOGIN} element={<LoginPage />} />
            <Route path={PATH_NAME.REGISTER} element={<RegisterPage />} />
            <Route path={PATH_NAME.VERIFY_OTP} element={<VertifyOTP />} />
            <Route path={PATH_NAME.PRIVACY_POLICY} element={<RefundPrivacyPolicyPage />} />
            <Route path={PATH_NAME.GUEST_PAYMENT} element={<GuestPayment />} />


            <Route
              path={PATH_NAME.FORGET_PASSWORD}
              element={<ForgetPasswordPage />}
            />
            <Route
              path={PATH_NAME.RESET_PASSWORD_VERIFY}
              element={<ResetPasswordOTPPage />}
            />
            {PRODUCT_ROUTE_PATHS.map((path) => (
              <Route key={path} path={path} element={<ProductPage />} />
            ))}
            <Route path={PATH_NAME.CART} element={<CartPage/>}/>
            <Route path={PATH_NAME.CHECKOUT} element={<Checkout />} />
          </Route>
          <Route element={<ProtectedLayout />}>
            <Route path={PATH_NAME.MEMBER} element={<MainLayout />}>
              {routes}
              {/* Wrap the Profile component with ThemeProvider */}
              <Route
                path={PATH_NAME.PROFILE}
                element={
                  <ThemeProvider theme={lightTheme}>
                    <Profile />
                  </ThemeProvider>
                }
              />
            </Route>
          </Route>
        </Routes>
      </ForceRefresh>
    </BrowserRouter>
  );
}

export default App;